import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { FieldError } from 'components/misc'
import fieldId from 'constants/layout/fieldId'
import styles from './time-picker.styl'

export default class TimePicker extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    optional: PropTypes.bool,
    max: PropTypes.number,
    step: PropTypes.number,
    intlKey: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired
  }

  static defaultProps = {
    required: false,
    max: 600,
    step: 15,
  }

  normalize = (value, prevValue) => isNaN(value) || value > this.props.max || value < 0
    ? prevValue
    : value

  incrMins = input => Number(input.value) + this.props.step > this.props.max
    ? input.onChange(0)
    : input.onChange(Number(input.value) + this.props.step)

  decrMins = input => Number(input.value) - this.props.step < 0
    ? input.onChange(this.props.max)
    : input.onChange(Number(input.value) - this.props.step)

  incrHours = input => Number(input.value) + 60 > this.props.max
    ? input.onChange(0)
    : input.onChange(Number(input.value) + 60)

  decrHours = input => Number(input.value) - 60 < 0
    ? input.onChange(this.props.max)
    : input.onChange(Number(input.value) - 60)

  renderField = field => {
    const { input } = field
    const { error, touched } = field.meta
    const inputClass = touched && error ? styles.formControlErr : styles.formControlValid
    const isError = touched && error

    const time = {
      hours: (Math.floor(input.value / 60)).toString() || '',
      minutes: (input.value % 60).toString() || '',
    }

    time.hours = get(time, 'hours').length === 1 ? `0${get(time, 'hours')}` : get(time, 'hours')
    time.minutes = get(time, 'minutes').length === 1 ? `0${get(time, 'minutes')}` : get(time, 'minutes')

    return (
      <div className={styles.formWrap}>
        <div className={styles.formControlWrap}>
          <div className={styles.inputWrap}>
            <div className={inputClass}>
              {input.value || input.value === 0
                ? get(time, 'hours')
                : 'hh'
              }
            </div>

            <div className={styles.arrowWrap}>
              <span className={`${styles.arrowUp} ico ico--chevron-down`} onClick={() => this.incrHours(input)} />
              <span className={`${styles.arrowDown} ico ico--chevron-down`} onClick={() => this.decrHours(input)} />
            </div>
          </div>

          <span className={styles.separator}>:</span>

          <div className={styles.inputWrap}>
            <div className={inputClass}>
              {input.value || input.value === 0
                ? get(time, 'minutes')
                : 'mm'
              }
            </div>

            <div className={styles.arrowWrap}>
              <span className={`${styles.arrowUp} ico ico--chevron-down`} onClick={() => this.incrMins(input)} />
              <span className={`${styles.arrowDown} ico ico--chevron-down`} onClick={() => this.decrMins(input)} />
            </div>
          </div>
        </div>

        <input type='hidden' {...input} />

        <FieldError toShow={isError} message={error} />
      </div>
    )
  }

  render() {
    const { label, name, intlKey, optional, disabled } = this.props
    const classNames = ['control-label']

    disabled && classNames.push('control-label-disabled')

    return (
      <div className='form-group' id={`${fieldId}.${name}`}>
        <label htmlFor={name} className={classNames.join(' ')}>
          {intlKey ? <FormattedMessage id={intlKey} defaultMessage={label} /> : label}
          {optional && <span> (<FormattedMessage id='label.optional' defaultMessage='optional' />)</span>}
        </label>
        <Field
          name={name}
          component={this.renderField}
          normalize={this.normalize}
        />
      </div>
    )
  }
}
